<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Shape Link</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <shape-form ref="shapeForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="shapeLinks"
        @save="save"
        @generate="generate"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import ShapeForm from './ShapeForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_SHAPE_MODEL_, MODEL } from './ShapeModel';

export default {
  name: 'ShapePage',
  components: {
    ShapeForm,
    SidebarActions,
  },
  computed: {
    shapeLinks() {
      const { shapeLinks } = this.$store.state.shapeLinks;
      if (shapeLinks) {
        Events.$emit(_LOAD_SHAPE_MODEL_, shapeLinks);
        return shapeLinks;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    generate() {
      this.$refs.shapeForm.generate();
    },
    save() {
      this.$refs.shapeForm.save();
    },
  },
};
</script>
